import moment from 'moment';
import { commonDescendingComparator, getUserPreferredFullName, momentDescendingComparator } from 'utils/helper';

const getPrettyRole = (role) => {
    return role === 'student' ? 'Student' : 'Instructor';
};

const getLastActivity = (activity) => {
    if (!activity) return null;
    return moment(activity.created_on);
};

export const COLUMNS = [
    {
        id: 'name',
        columnTitle: 'Name',
        comparator: (order, accountUsers) => {
            if (!order) return accountUsers;
            const getter = (user) => {
                return getUserPreferredFullName(user) || user.email;
            };

            if (order === 'desc') {
                const sortedUsers = [...accountUsers].sort((a, b) => commonDescendingComparator(a, b, getter));
                return sortedUsers;
            }
            const sortedUsers = [...accountUsers].sort((a, b) => -commonDescendingComparator(a, b, getter));
            return sortedUsers;
        },
    },
    {
        id: 'email',
        columnTitle: 'Email',
        comparator: (order, accountUsers) => {
            if (!order) return accountUsers;
            const getter = (user) => {
                return user.email;
            };

            if (order === 'desc') {
                const sortedUsers = [...accountUsers].sort((a, b) => commonDescendingComparator(a, b, getter));
                return sortedUsers;
            }
            const sortedUsers = [...accountUsers].sort((a, b) => -commonDescendingComparator(a, b, getter));
            return sortedUsers;
        },
    },
    {
        id: 'role',
        columnTitle: 'Role',
        // comparator: (order, accountUsers) => {
        //     if (!order) return accountUsers;
        //     const getter = (user) => {
        //         return getPrettyRole(user.role);
        //     };

        //     if (order === 'desc') {
        //         const sortedUsers = [...accountUsers].sort((a, b) => commonDescendingComparator(a, b, getter));
        //         return sortedUsers;
        //     }
        //     const sortedUsers = [...accountUsers].sort((a, b) => -commonDescendingComparator(a, b, getter));
        //     return sortedUsers;
        // },
    },
    {
        id: 'activity',
        columnTitle: 'Last Activity',
        comparator: (order, accountUsers) => {
            if (!order) return accountUsers;
            const getter = (user) => {
                return getLastActivity(user.login_activity);
            };

            if (order === 'desc') {
                const sortedUsers = [...accountUsers].sort((a, b) => momentDescendingComparator(a, b, getter));
                return sortedUsers;
            }
            const sortedUsers = [...accountUsers].sort((a, b) => -momentDescendingComparator(a, b, getter));
            return sortedUsers;
        },
    },
];
